module.exports = __webpack_public_path__ + "static/media/Sports_Club_Logo_Red_Grey.de3f0c8b.png";